export const telegramProfileRegExp = new RegExp('^(?:https:\\/\\/t\\.me\\/|@)([A-Za-z0-9_]{5,})$');

export const instagramProfileRegExp = new RegExp(
    '^(?:https://www\\.instagram\\.com/|@)([A-Za-z0-9_.]+)$',
);

export const vkProfileRegExp = new RegExp('^(?:https://vk\\.(?:com|ru)/|@)([A-Za-z0-9_.]+)$');

export const youtubeProfileRegExp = new RegExp('^https://youtube\\.com/@([A-Za-z0-9_.]+)$');

export const bloggersRegisterProfileRegExp = new RegExp('^https://www\\.gosuslugi\\.ru/(.+)$');

export const publicIdRegExp = new RegExp('^@.+$', 'i');

export const excludeCyrillicRegExp = new RegExp('^[^а-яА-Я]+$', 'i');

export const excludeSymbolsRegExp = new RegExp('^[^;<>/]+$', 'i');

export const bikRegExp = new RegExp('^\\d{9}$');

export const accountNumberRegExp = new RegExp('^\\d{20}$');

const instagramLinkRegExp = new RegExp('^.*(instagram\\.com).*$', 'i');

const vkLinkRegExp = new RegExp('^.*(vk\\.(?:com|ru)).*$', 'i');

const facebookLinkRegExp = new RegExp('^.*(facebook\\.com).*$', 'i');

const youtubeLinkRegExp = new RegExp('^.*(youtube\\.com).*$', 'i');

const youtuLinkRegExp = new RegExp('^.*(youtu\\.be).*$', 'i');

const pinterestLinkRegExp = new RegExp('^.*(pinterest\\.com).*$', 'i');

const pinItLinkRegExp = new RegExp('^.*(pin\\.it).*$', 'i');

const rutubeLinkRegExp = new RegExp('^.*(rutube\\.ru).*$', 'i');

const dzenLinkRegExp = new RegExp('^.*(dzen\\.ru).*$', 'i');

export const tBotDetection = new RegExp('^.*(TelegramBot).*$', 'i');

export const clickOutBlackListRegexps = [
    instagramLinkRegExp,
    vkLinkRegExp,
    facebookLinkRegExp,
    youtubeLinkRegExp,
    youtuLinkRegExp,
    pinterestLinkRegExp,
    pinItLinkRegExp,
    rutubeLinkRegExp,
    dzenLinkRegExp,
];

export const dateRegExp = new RegExp('^\\d{4}\\-\\d{2}\\-\\d{2}$');

export const passportRegExp = new RegExp('^\\d{10}$');

export const subdivisionCodeRegExp = new RegExp('^\\d{6}$');

export const indexRegExp = new RegExp('^\\d{6}$');

export const snilsNumberRegExp = new RegExp('^\\d{11}$');

export const innOgrnRegExp = new RegExp('^\\d{10,15}$');
